export enum NoteUrgency {
    Emergency,
    HighProirity,
    MediumPriority,
    LowPriority
}